import { useContext } from "react";
import { UsernameContext } from "../App";
import {Route , Routes , Link} from "react-router-dom";
function Home(props){
    const { username } = useContext(UsernameContext);
    
    return(
        <div className="home-title" style={{color: "white"}}>
           <h1>WELCOME TO {props.platformName.toUpperCase()}</h1>
           <p>Website under construction...</p>
           <p>But here's some quiz: </p>
           <Link to="/learning/content" className="nav-item quiz-button">Go to Quiz</Link>
        </div>
    )
}

export default Home;